import { combineReducers } from "redux";
import booksReducer from "./features/Books/bookReducer";
import editReducer from "./features/Edit/editReducer";
import filterReducer from "./features/Filter/filterreducer";

const rootReducer = combineReducers({
 books: booksReducer,
 filter: filterReducer,
 edit: editReducer,
});
export default rootReducer;
